import creator from "./creator";
import select from "./select";
export default function (name) {
  return select(creator(name).call(document.documentElement));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-selection@1.4.1@d3-selection/src/create.js
// module id = 422
// module chunks = 0